import { useReducer } from 'react';

const formReducer = (state, action) => {

    switch (action.type) { // spell check the action type you passed to the dispatch method
        case 'updateField':
            return Object.assign({}, state, { [action.key]: action.value })
        case 'clearField':
            return Object.keys(state).reduce((object, key) => {
                if (key !== action.key) { object[key] = state[key] }
                return object
            }, {})
        case 'setMessage':
            return Object.assign({}, state, { message: { type: action.key, text: action.value } })
        case 'clearMessage':
            return Object.assign({}, state, { message: null })
        case 'toggleSubmitting':
            return Object.assign({}, state, { submitting: !state.submitting })    
        default:
            throw new Error() // spell check the action type you passed to the dispatch method

    }
}

const useFormReducer = () => useReducer(formReducer, {});

export default useFormReducer